import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useMemo, useEffect } from "react";
import { useIntl } from "react-intl";
import { useQuery, useMutation, useLazyQuery } from "@apollo/client";
import { useCartContext } from "@magento/peregrine/lib/context/cart";
import { APPLY_COUPON_MUTATION, REMOVE_COUPON_MUTATION, GET_APPLIED_COUPONS } from "@overrides_venia/venia-ui/components/CartPage/PriceAdjustments/CouponCode/coupons.gql";
import { GET_CUSTOMER } from "../../SignIn/signIn.gql";
import { showNotification } from "@Components/Notification/Notification";
import { useExponea } from "@Src_main/utils/useExponea";
export var useCouponCode = props => {
  var [{
    cartId,
    details
  }, {
    updateCartData
  }] = useCartContext();
  var {
    trackEvent
  } = useExponea();
  var {
    formatMessage
  } = useIntl();
  var [applyCoupon, {
    error: applyError,
    loading: applyingCoupon
  }] = useMutation(APPLY_COUPON_MUTATION);
  var [getAvailableCoupon, {
    error: getAvailableCouponError,
    loading: getAvailableCouponLoading,
    data: availableCoupon
  }] = useLazyQuery(GET_CUSTOMER);
  var [removeCoupon, {
    error: removeCouponError,
    loading: removingCoupon
  }] = useMutation(REMOVE_COUPON_MUTATION);
  var appliedCoupon = useMemo(() => {
    var _details$applied_coup;
    return (details === null || details === void 0 ? void 0 : (_details$applied_coup = details.applied_coupons) === null || _details$applied_coup === void 0 ? void 0 : _details$applied_coup.length) > 0 ? details.applied_coupons[0].code : null;
  }, [details]);
  var handleApplyCoupon = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (couponCode, onSuccess, onError) {
      if (!couponCode) return;
      try {
        yield applyCoupon({
          variables: _objectSpread({
            cartId
          }, couponCode),
          onCompleted: data => {
            trackEvent("apply_coupon", {
              coupon: couponCode
            });
            updateCartData(data.applyCouponToCart.cart);
            showNotification({
              message: formatMessage({
                id: "coupon.success.add.title"
              }),
              status: 'success',
              iconName: 'icon-check',
              iconColor: 'success',
              bold: true
            });
            if (onSuccess) onSuccess(data);
          },
          onError: error => {
            showNotification({
              message: error,
              status: 'danger',
              iconName: 'icon-info',
              iconColor: 'danger',
              bold: true
            });
            if (onError) onError(error);
          }
        });
      } catch (e) {
        if (onError) onError(e);
      }
    });
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }(), [applyCoupon, cartId]);
  var handleRemoveCoupon = useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (couponCode, onSuccess, onError) {
      try {
        yield removeCoupon({
          variables: {
            cartId
          },
          onCompleted: data => {
            trackEvent("remove_coupon", {
              coupon: couponCode
            });
            updateCartData(data.removeCouponFromCart.cart);
            showNotification({
              message: formatMessage({
                id: "coupon.success.remove.title"
              }),
              status: 'warning',
              iconName: 'icon-check',
              iconColor: 'warning',
              bold: true
            });
            if (onSuccess) onSuccess(data);
          },
          onError: error => {
            showNotification({
              message: error,
              status: 'danger',
              iconName: 'icon-info',
              iconColor: 'danger',
              bold: true
            });
            if (onError) onError(error);
          }
        });
        if (callback) callback();
      } catch (e) {
        if (onError) onError(e);
      }
    });
    return function (_x4, _x5, _x6) {
      return _ref2.apply(this, arguments);
    };
  }(), [cartId, removeCoupon]);

  // Create a memoized error map and toggle individual errors when they change
  var errors = useMemo(() => new Map([["applyCouponMutation", applyError], ["removeCouponMutation", removeCouponError]]), [applyError, removeCouponError]);
  return {
    applyingCoupon,
    appliedCoupon,
    errors,
    handleApplyCoupon,
    handleRemoveCoupon,
    removingCoupon,
    getAvailableCoupon,
    availableCoupon,
    isLoading: applyingCoupon || removingCoupon
  };
};